var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VBtn',_vm._g({style:(_vm.style),attrs:{"role":"tab","color":_vm.btnColor,"aria-controls":_vm.ariaControls,"aria-selected":_vm.selected,"tabindex":_vm.tabindex,"ripple":false,"elevation":"0"}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }